import {
	ProductData,
	ProductVariant,
	ProductBulkPricing,
} from "@/lib/5874/types";

export type PriceType = "base" | "sale" | "bulk";

export type PriceAlias = "pricesIncTax" | "pricesExTax";

const useProductPricing = () => {
	const getPriceObject = (
		productOrVariant: ProductData | ProductVariant,
		key: PriceAlias,
		quantity: number,
	) => {
		type PriceType = "base" | "sale" | "bulk";
		type PriceAlias = "pricesIncTax" | "pricesExTax";

		const getFromPriceForProduct = () => {
			const variants = (productOrVariant as ProductData).variants || [];

			if (variants.length === 0) {
				return null;
			}

			const minValue = Math.min(
				...variants
					.filter((variant) => variant.isPurchasable)
					.map((variant) => {
						// const price = showVat ? variant.pricesIncTax : variant.pricesExTax;
						const price = variant.pricesExTax;

						return price?.price?.value || 0;
					}),
			);

			const variant = variants.find((variant) => {
				const value = variant.pricesExTax?.price?.value;
				// const value = showVat
				// 	? variant.pricesIncTax?.price?.value
				// 	: variant.pricesExTax?.price?.value;

				return value === minValue;
			});

			if (!variant) {
				return null;
			}

			return getCorrectPrices(variant);
		};

		const bcPrices = productOrVariant[key];

		const prices = {
			base: bcPrices?.basePrice?.value,
			price: bcPrices?.price?.value,
			sale: bcPrices?.salePrice?.value,
			saved: bcPrices?.saved?.value,
			bulkPricing: bcPrices?.bulkPricing || ([] as ProductBulkPricing[]),
			currencyCode: bcPrices?.price?.currencyCode,
		};

		const from = getFromPriceForProduct();

		// const activeBulkPricing = getActiveBulkPricing(productOrVariant, quantity);

		// const type = activeBulkPricing ? 'bulk' : prices.sale ? 'sale' : 'base';

		return {
			from: from && {
				...from,
			},
			...prices,
			// price: activeBulkPricing ? activeBulkPricing.value : prices.price,
			// bulkSaving: activeBulkPricing?.saving,
			// type: type as PriceType,
		};
	};

	/**
	 * Get the correct pricing depending on the 'show vat' switch
	 * @param productOrVariant
	 * @returns
	 */
	const getCorrectPrices = (productOrVariant: ProductData | ProductVariant) => {
		let prices;

		// if (showVat)
		// 	prices = {
		// 		base: productOrVariant.pricesIncTax.basePrice.value,
		// 		price: productOrVariant.pricesIncTax.price.value,
		// 		sale: productOrVariant.pricesIncTax.salePrice?.value,
		// 		saved: productOrVariant.pricesIncTax.saved?.value,
		// 		bulkPricing:
		// 			productOrVariant.pricesIncTax.bulkPricing ||
		// 			([] as ProductBulkPricing[]),
		// 		currencyCode: productOrVariant.pricesIncTax.price.currencyCode,
		// 	};
		// else
		prices = {
			base: productOrVariant.pricesExTax?.basePrice?.value,
			price: productOrVariant.pricesExTax?.price?.value,
			sale: productOrVariant.pricesExTax?.salePrice?.value,
			saved: productOrVariant.pricesExTax?.saved?.value,
			bulkPricing:
				productOrVariant.pricesExTax?.bulkPricing ||
				([] as ProductBulkPricing[]),
			currencyCode: productOrVariant.pricesExTax?.price?.currencyCode,
		};

		return prices;
	};

	const getProductOrVariantPricing = (
		productOrVariant: ProductData | ProductVariant,
		quantity = 1,
	) => {
		if (productOrVariant._type === "Product") {
			quantity = productOrVariant?.purchasability?.minQuantity || 1;
			const incVat = getPriceObject(productOrVariant, "pricesIncTax", quantity);
			const exVat = getPriceObject(productOrVariant, "pricesExTax", quantity);

			return {
				incVat,
				exVat,
				active: exVat,
				// active: showVat ? incVat : exVat,
			};
		}
	};

	return {
		// incVat: showVat,
		getProductOrVariantPricing,
	};
};

export default useProductPricing;
